import { UtilitesState, ToggleDebugModeActon, AddErrorMessageAction, ClearDebugMessageListAction } from "./type";

export function changeDebugModeState(state: UtilitesState, action: ToggleDebugModeActon): UtilitesState {
    return Object.assign({}, state, { isScanning: action.payload.isDemoModeActive });
}

export function addErrorMessage(state: UtilitesState, action: AddErrorMessageAction): UtilitesState {
    return Object.assign({...state}, { messages: [...state.messages, {...action.payload }]});
}

export function clearDebugMessageList(state: UtilitesState, action: ClearDebugMessageListAction): UtilitesState {
    return Object.assign({...state}, { messages: []});
}


// WEBPACK FOOTER //
// ./src/store/Utilities/handlers.ts